// PlaceholderImage — no real image loading needed

interface PlaceholderImageProps {
  height?: string;
  label?: string;
  src?: string;
  alt?: string;
  className?: string;
}

export function PlaceholderImage({
  height = "h-[280px]",
  label = "Image",
  src,
  alt = "",
  className = ""
}: PlaceholderImageProps) {
  if (src) {
    return (
      <div
        className={`relative ${height} bg-bg-surface border border-border rounded-xl overflow-hidden ${className}`}
      >
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      className={`${height} bg-bg-surface border border-border rounded-xl flex items-center justify-center ${className}`}
    >
      <span className="text-text-muted text-xs font-body uppercase tracking-widest">
        {label}
      </span>
    </div>
  );
}
